import type { BlobDataRequest, BlobDataResponse } from '../blob'
import type { BlobRequestDTO, BlobResponseDTO } from '../dto/blob-dto'

const mapToBlobResponseDTO = ({ path, url }: BlobDataResponse): BlobResponseDTO => {
    return {
        path,
        url,
    }
}

const mapToBlobResponse = ({ path, url }: BlobResponseDTO): BlobDataResponse => {
    return {
        path: path ?? undefined,
        url: url ?? undefined,
    }
}

const mapToBlobRequestDTO = ({ blob, folder }: BlobDataRequest): BlobRequestDTO => {
    return {
        Blob: blob,
        Folder: folder,
    }
}

const mapToBlobRequest = ({ Blob, Folder }: BlobRequestDTO): BlobDataRequest => {
    return {
        blob: Blob,
        folder: Folder,
    }
}

export { mapToBlobRequest, mapToBlobRequestDTO, mapToBlobResponse, mapToBlobResponseDTO }
